const firebaseConfig = {
    apiKey: "AIzaSyBNgURyIb5mokYVGoKishxToYcJHnG0YGQ",
    authDomain: "redhot-onion.firebaseapp.com",
    projectId: "redhot-onion",
    storageBucket: "redhot-onion.appspot.com",
    messagingSenderId: "787578197007",
    appId: "1:787578197007:web:e69641b9accf02d037bf7a"
};

export default firebaseConfig